import { useAppShell } from "../AppShellContext";

// Removed "you" – now lives in top bar
const TABS = [
  { id: "home",    icon: "🏠", label: "Home" },
  { id: "explore", icon: "🌿", label: "Explore" },
  { id: "saksham", icon: "🤖", label: "Saksham" },
  { id: "connect", icon: "💬", label: "Connect" },
  { id: "mentor",  icon: "🤝", label: "Mentors" },
];

export default function BottomTabBar() {
  const { activeTab, setActiveTab } = useAppShell();

  return (
    <nav className="hh-tabbar" role="tablist">
      {TABS.map(tab => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-label={tab.label}
          className={`hh-tab${activeTab === tab.id ? " active" : ""}${tab.id === "saksham" ? " saksham" : ""}`}
          onClick={() => {
            if (typeof window !== "undefined" && window.navigator?.vibrate) {
              window.navigator.vibrate(15);
            }
            setActiveTab(tab.id);
          }}
        >
          <span className="hh-tab-icon">{tab.icon}</span>
          <span className="hh-tab-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}